// api.ts - Az API hívások kezelése natív fetch segítségével

// Típusok hozzáadása
interface Business {
    name: string;
    place_id: string;
    address: string;
  }
  
  interface ApiResponse<T> {
    data: T;
    status: string;
    message: string;
  }
  
  // Az alap fetch wrapper, amely minden API hívásnál használható
  export const fetchWrapper = async (url: string, options: RequestInit = {}) => {
    try {
      const response = await fetch(url, options); // Fetch hívás
      if (!response.ok) {
        const errorResponse = await response.text();
        throw new Error(`Request failed with status: ${response.status}, Response: ${errorResponse}`);
      }
      return await response.json(); // A válasz JSON-ban
    } catch (error) {
      console.error('Fetch error:', error);
      throw error; // Hibát dobunk, ha valami elromlik
    }
  };
  
  // Az alapértelmezett mock válaszok
  const mockData: Business[] = [
    { name: 'GastroSol Restaurant', place_id: '1', address: '123 Main Street' },
    { name: 'GastroSol Cafe', place_id: '2', address: '456 Side Street' },
    { name: 'GastroSol Bakery', place_id: '3', address: '789 Market Avenue' },
  ];
  
  // Az API endpoint elérhetősége
  const useMockApi = false; // Itt állítható be, hogy mock adatokat használjunk-e
  
  // API hívás a vállalkozások kereséséhez (szimulálva a valós API-t)
  export const fetchBusinessSuggestions = async (query: string): Promise<Business[]> => {
    if (useMockApi) {
      // Ha a mock adatokat használjuk, akkor szűrjük a mockData-t
      return mockData.filter(business =>
        business.name.toLowerCase().includes(query.toLowerCase())
      );
    }
  
    // Ha az API elérhető, használjuk azt
    const encodedQuery = encodeURIComponent(query);
    const url = `https://api.gastrosol.hu/gbp/nameautocomplete?query=${encodedQuery}`;
    console.log("Sending Suggestion request to url:", url)
    const response = await fetch(url);
    const data = await response.json();
    console.log("Recieved response data:", data)

    const businesses: Business[] = data.results.map((result: any) => ({
      name: result.name,
      place_id: result.place_id,
      address: result.address,
    }));

    return businesses || []; // Visszaadjuk a válaszban lévő adatokat
  };
  
  // API hívás a vállalkozás hozzáféréséhez (új API hívás)
  export const requestBusinessAccess = async (placeId: string, businessName: string): Promise<ApiResponse<any>> => {
    const url = 'https://api.gastrosol.hu/gbp/business-access-service';
    const options: RequestInit = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        place_id: placeId,
        place_name: businessName,
      }),
    };
  
    return await fetchWrapper(url, options); // API válasz kezelése
  };
  
